module.exports = __webpack_public_path__ + "img/circle.b66d9a77.svg";